var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "background" }, [
    _vm._m(0),
    _c("div", { staticClass: "main-box" }, [
      _c(
        "div",
        { staticClass: "logo" },
        [_c("el-image", { attrs: { src: _vm.chatInfo.icon } })],
        1
      ),
      _c(
        "div",
        {
          ref: "chatListBox",
          staticClass: "chat-list",
          on: {
            dragover: function ($event) {
              $event.preventDefault()
            },
            dragenter: function ($event) {
              $event.preventDefault()
            },
            drop: _vm.handleFileDrop,
          },
        },
        [
          _c(
            "div",
            { staticClass: "chat-box answer" },
            [
              _c("el-image", {
                staticClass: "chat-avatar",
                attrs: { src: _vm.chatInfo.icon },
              }),
              _c("div", { staticClass: "chat-content" }, [
                _vm._v(_vm._s(_vm.chatInfo.prologue)),
              ]),
            ],
            1
          ),
          _vm._l(_vm.chatRecords, function (item, index) {
            return [
              item.type === "question"
                ? _c(
                    "div",
                    { key: index, staticClass: "chat-box question" },
                    [
                      item.files.length > 0
                        ? [
                            _vm._l(item.files, function (file) {
                              return _c(
                                "div",
                                { key: file.file_id, staticClass: "chat-file" },
                                [
                                  _c("p", { staticClass: "file-name" }, [
                                    _vm._v(_vm._s(file.file_name)),
                                  ]),
                                  _c("p", { staticClass: "file-info" }, [
                                    _vm._v(
                                      _vm._s(file.file_ext) +
                                        " · " +
                                        _vm._s(file.file_size)
                                    ),
                                  ]),
                                ]
                              )
                            }),
                            _c("div", { staticClass: "break" }),
                          ]
                        : _vm._e(),
                      _vm.translateLoading &&
                      index === _vm.chatRecords.length - 1
                        ? _c("div", { staticClass: "chat-content" }, [
                            _vm._m(1, true),
                          ])
                        : _c("div", { staticClass: "chat-content" }, [
                            _vm._v(_vm._s(item.content)),
                          ]),
                    ],
                    2
                  )
                : _vm._e(),
              item.type === "answer"
                ? _c(
                    "div",
                    { key: index, staticClass: "chat-box answer" },
                    [
                      _c("el-image", {
                        staticClass: "chat-avatar",
                        attrs: { src: _vm.chatInfo.icon },
                      }),
                      _c("div", { staticClass: "chat-content" }, [
                        _vm.showLoading && index === _vm.chatRecords.length - 1
                          ? _c(
                              "div",
                              {
                                staticClass: "think-loading",
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleThinkDom(index)
                                  },
                                },
                              },
                              [_vm._m(2, true)]
                            )
                          : _vm._e(),
                        _vm.chatInfo.is_think && !_vm.showLoading
                          ? _c(
                              "div",
                              {
                                staticClass: "finish-loading",
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleThinkDom(index)
                                  },
                                },
                              },
                              [
                                _c("span", [_vm._v("思考结束")]),
                                !_vm.showThinkStatus[index]
                                  ? _c("i", {
                                      staticClass: "el-icon-arrow-down",
                                    })
                                  : _c("i", {
                                      staticClass: "el-icon-arrow-up",
                                    }),
                              ]
                            )
                          : _vm._e(),
                        _c("div", {
                          attrs: { id: `answer-${index}` },
                          domProps: { innerHTML: _vm._s(item.formatContent) },
                        }),
                      ]),
                      _c("div", { staticClass: "operation-box" }, [
                        _c("i", {
                          staticClass: "el-icon-document-copy",
                          on: {
                            click: function ($event) {
                              return _vm.copyContent(item.content)
                            },
                          },
                        }),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _c("div", { staticClass: "chat-options" }, [
        _c(
          "div",
          {
            staticClass: "option-item",
            class: { active: _vm.searchEnabled },
            on: {
              click: function ($event) {
                return _vm.changeSearchEnable()
              },
            },
          },
          [
            _c("el-image", {
              class: _vm.searchEnabled ? "search-btn active" : "search-btn",
              attrs: {
                src: _vm.searchEnabled
                  ? _vm.SearchIconWhite
                  : _vm.SearchIconBlue,
              },
            }),
            _c("span", [_vm._v("联网搜索")]),
          ],
          1
        ),
        _vm.useDigitalPerson && _vm.isSmallDevice
          ? _c(
              "div",
              { staticClass: "option-item", on: { click: _vm.redirectToCall } },
              [
                _c("el-image", { attrs: { src: _vm.CallIcon } }),
                _c("span", [_vm._v("打电话")]),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c("div", { staticClass: "chat-input-box" }, [
        _vm.inputType === "text"
          ? _c(
              "div",
              {
                staticClass: "input-outline",
                class: { "drag-over": _vm.isDragOver },
                on: {
                  dragover: function ($event) {
                    $event.preventDefault()
                    return _vm.handleDragOver.apply(null, arguments)
                  },
                  dragleave: _vm.handleDragLeave,
                  drop: _vm.handleInputDrop,
                },
              },
              [
                _c("div", { staticClass: "input-box" }, [
                  _vm.uploadedFile.length > 0
                    ? _c(
                        "div",
                        { staticClass: "files-box" },
                        _vm._l(_vm.uploadedFile, function (item) {
                          return _c(
                            "div",
                            {
                              key: item.file_id,
                              staticClass: "file-item",
                              on: { click: _vm.removeFile },
                            },
                            [
                              _c("p", { staticClass: "file-name" }, [
                                _vm._v(_vm._s(item.file_name)),
                              ]),
                              _c("p", { staticClass: "file-info" }, [
                                _vm._v(
                                  _vm._s(item.file_ext) +
                                    " · " +
                                    _vm._s(item.file_size)
                                ),
                              ]),
                              _c("i", {
                                staticClass: "el-icon-error close-icon",
                              }),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "input-container" },
                    [
                      _c("el-image", {
                        staticClass: "switch-icon",
                        attrs: { src: _vm.VoiceIcon },
                        on: {
                          click: function ($event) {
                            return _vm.switchInputType("voice")
                          },
                        },
                      }),
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: _vm.fileUploading
                            ? "正在处理文件..."
                            : "请输入您的问题",
                          autosize: { minRows: 1, maxRows: 4 },
                          resize: "none",
                          disabled: _vm.fileUploading,
                        },
                        model: {
                          value: _vm.inputContent,
                          callback: function ($$v) {
                            _vm.inputContent = $$v
                          },
                          expression: "inputContent",
                        },
                      }),
                      _vm.fileUploading
                        ? _c("div", { staticClass: "file-uploading" }, [
                            _c("i", { staticClass: "el-icon-loading" }),
                            _c("span", [_vm._v("文件处理中...")]),
                          ])
                        : _vm._e(),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "上传附件（仅识别文字）",
                            placement: "top",
                          },
                        },
                        [
                          _c("el-image", {
                            staticClass: "search-btn",
                            attrs: { src: _vm.AttachmentIcon },
                            on: { click: _vm.triggerFileUpload },
                          }),
                        ],
                        1
                      ),
                      _c("input", {
                        ref: "fileInput",
                        staticStyle: { display: "none" },
                        attrs: {
                          type: "file",
                          accept:
                            ".jpg,.jpeg,.png,.txt,.doc,.docx,.xls,.xlsx,.csv,.ppt,.pptx,.pdf",
                        },
                        on: { change: _vm.handleFileSelect },
                      }),
                      _vm.generating
                        ? _c("el-image", {
                            staticClass: "send-btn active",
                            attrs: { src: _vm.StopIcon },
                            on: { click: _vm.stopGenerating },
                          })
                        : _vm.inputContent && !_vm.generating
                        ? _c("el-image", {
                            staticClass: "send-btn",
                            class: { active: _vm.inputContent },
                            attrs: { src: _vm.SendIconWhite },
                            on: {
                              click: function ($event) {
                                return _vm.sendMessage()
                              },
                            },
                          })
                        : _c("el-image", {
                            staticClass: "send-btn",
                            class: { active: _vm.inputContent },
                            attrs: { src: _vm.SendIconBlue },
                          }),
                    ],
                    1
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm.inputType === "voice"
          ? _c(
              "div",
              {
                staticClass: "voice-outline",
                on: {
                  mouseup: _vm.stopRecord,
                  touchend: _vm.stopRecord,
                  mouseleave: _vm.mouseLeaveArea,
                  mousemove: _vm.touchOrClickMove,
                  touchmove: _vm.touchOrClickMove,
                },
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showVoiceStatus,
                        expression: "showVoiceStatus",
                      },
                    ],
                    staticClass: "voice-display",
                  },
                  [
                    _c("div", { staticClass: "voice-tips" }, [
                      _vm._v("我在听，请说话"),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "voice-operation",
                        style: {
                          color: _vm.voiceCancel ? "#FF8282" : "#84888B",
                        },
                      },
                      [
                        _vm.voiceCancel
                          ? _c("span", [_vm._v("松开取消")])
                          : _c("span", [_vm._v("松开发送， 上滑取消")]),
                      ]
                    ),
                    _c("div", {
                      ref: "voiceWave",
                      staticClass: "voice-wave",
                      staticStyle: { width: "100%", height: "40px" },
                    }),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "voice-box" },
                  [
                    _c("el-image", {
                      staticClass: "switch-icon",
                      attrs: { src: _vm.KeyboardIcon },
                      on: {
                        click: function ($event) {
                          return _vm.switchInputType("text")
                        },
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "voice-btn",
                        on: {
                          mousedown: _vm.startRecord,
                          touchstart: _vm.startRecord,
                        },
                      },
                      [_vm._v("按住说话")]
                    ),
                    true
                      ? _c("el-image", {
                          staticClass: "send-btn",
                          class: { active: _vm.generating },
                          attrs: { src: _vm.StopIcon },
                          on: { click: _vm.stopGenerating },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
        _c("div", { staticClass: "content-tips" }, [
          _vm._v("内容由AI大模型生成，仅供参考。"),
        ]),
      ]),
      _vm.useDigitalPerson
        ? _c("div", { staticClass: "digital-person" }, [
            _vm.digitalPersonSpeaking
              ? _c("img", {
                  staticClass: "jsmpeg",
                  attrs: { src: _vm.SpeakDigitalPerson },
                })
              : _c("img", {
                  staticClass: "jsmpeg",
                  attrs: { src: _vm.NoSpeakDigitalPerson },
                }),
          ])
        : _vm._e(),
      _c("audio", {
        ref: "audio",
        attrs: { src: _vm.currentVoice, preload: "auto" },
      }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "rainbow-box" }, [
      _c("i", { staticClass: "color-block color-1" }),
      _c("i", { staticClass: "color-block color-2" }),
      _c("i", { staticClass: "color-block color-3" }),
      _c("i", { staticClass: "color-block color-4" }),
      _c("i", { staticClass: "color-block color-5" }),
      _c("i", { staticClass: "color-block color-6" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "translate-loading" }, [
      _c("div", [_c("i"), _c("i"), _c("i")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_vm._v("正在思考"), _c("i"), _c("i"), _c("i")])
  },
]
render._withStripped = true

export { render, staticRenderFns }